module.exports = __webpack_public_path__ + "img/Menu-06.b5c7f690.png";